<template>
    <div>
        <component
            :is="component"
            v-for="(product, index) in offers"
            :key="product.name"
            :product="product"
            :data-cy="`cruise-offer-${index}`"
            :class="contentClass"
            :is-package="isPackage"
        >
            <template v-slot:price="{offer}">
                <slot name="price" :offer="offer" />
            </template>
        </component>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import SimpleTourCard from '~src/components/simpleTours/search/offers/SimpleTourCard.vue'
    import SimpleTourCardMobile from '~src/components/simpleTours/search/offers/SimpleTourCardMobile.vue'

    @Component({
        components: {
            SimpleTourCard,
            SimpleTourCardMobile,
        },
    })
    export class SimpleTourOffers extends Vue {
        @Prop({default: () => []}) offers
        @Prop() contentClass
        @Prop({default: false, type: Boolean}) isPackage

        get component() {
            return this.$breakpoint.smAndDown
                ? resolveComponent('SimpleTourCardMobile')
                : resolveComponent('SimpleTourCard')
        }
    }

    export default SimpleTourOffers
</script>
